import {isNullOrUndefined} from "../../../services/Validator";
import {useNavigate} from "react-router-dom";
import {kInternalRoutes} from "../../../constants/internalRoutes";
import BrevetHorizontalStarDivider from "../../dividers/brevetScreen/BrevetHorizontalStarDivider";
import BrevetLevelAMediaList from "../../lists/brevetScreen/BrevetLevelAMediaList";
import BrevetLevelASubthemeNameText from "../../texts/brevetScreen/BrevetLevelASubthemeNameText";
import BrevetLevelATaskText from "../../texts/brevetScreen/BrevetLevelATaskText";
import BrevetLevelAGradeText from "../../texts/brevetScreen/BrevetLevelAGradeText";
import BrevetLevelASeeDetailButton from "../../buttons/brevetScreen/BrevetLevelASeeDetailButton";

export default function BrevetLevelAsItem({index, total, levelA}) {
    // Used in BrevetLevelAsList to display one single
    // LevelA

    // PROPERTIES
    let navigate = useNavigate()

    // BUILD
    if (isNullOrUndefined(levelA))
        return null
    return (
        <div className="w-full flex flex-col space-y-[8px]">
            <div className={"w-full grid grid-cols-[5fr_3fr_120px_200px_120px] gap-[16px] items-center px-[24px] mt-[8px]"}>
                <BrevetLevelATaskText text={levelA?.task} />
                <BrevetLevelASubthemeNameText text={levelA?.levelASubtheme?.name} />
                <BrevetLevelAGradeText text={levelA?.levelAGrade.name} />
                <BrevetLevelAMediaList levelA={levelA} />
                <BrevetLevelASeeDetailButton onButtonClick={() => goToLevelAScreen(levelA?.slug)} />
            </div>
            {index === (total - 1) ? <div className={"h-[12px]"}></div> : <BrevetHorizontalStarDivider />}
        </div>

    );

    // METHODS
    // ---- NAV : Navigate to LevelAScreen with current LevelA
    function goToLevelAScreen(slug) {
        navigate(`/savoir-faire/${slug}`, {
            state: { from: kInternalRoutes.brevet }
        })
    }
}